<script>
  import Layout from '@/router/layouts/main';
  import appConfig from '@/app.config';
  const numeral = require('numeral');
  import PageHeader from '@/components/page-header';
  import { mapGetters } from 'vuex';

  import LineChart from '@/components/widgets/LineChart.vue';
  import ListProject from './ListProject.vue';
  import ICountUp from 'vue-countup-v2';
  import WithdrawVND from '../Wallet/WithdrawVND.vue';
  import TransferVND from '../Wallet/TransferVND.vue';
  import InfoInvestment from '@/views/Profile/InfoInvestment';

  export default {
    page: {
      title: 'Tổng Quan',
      meta: [{ name: 'Tổng Quan', content: appConfig.description }],
    },
    components: {
      Layout,
      PageHeader,
      'Line-Chart': LineChart,
      ListProject,
      ICountUp,
      'withdraw-vnd': WithdrawVND,
      InfoInvestment,
      'transfer-vnd': TransferVND,
    },
    data() {
      return {
        title: 'Tổng Quan',
        items: [
          {
            text: 'Hệ Thống',
            href: '/',
          },
          {
            text: 'Tổng Quan',
            active: true,
          },
        ],
        projectID: null,
        showChart: true,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ' VND',
          decimalPlaces: 0,
        },
        type: 'date',
        listFilter: [
          { value: 'date', text: 'Ngày' },
          { value: 'month', text: 'Tháng' },
          { value: 'year', text: 'Năm' },
        ],
      };
    },
    watch: {
      Chart: {
        handler() {
          this.showChart = false;
          this.$nextTick(() => {
            this.showChart = true;
          });
        },
      },
      projectID: {
        handler() {
          this.$store.dispatch('dashboard/req_getChartData', {
            project: this.projectID,
            date_type: this.type,
          });
        },
      },
      ListProject: {
        handler() {
          if (this.ListProject.length) {
            this.projectID = this.ListProject[0].project_id;
          }
        },
      },
      type: {
        handler() {
          this.$store.dispatch('dashboard/req_getChartData', {
            project: this.projectID,
            date_type: this.type,
          });
        },
      },
    },
    computed: {
      ...mapGetters({
        Rate: 'wallet/Rate',
        Statistical: 'dashboard/Statistical',
        Project: 'investment/ProjectInvestment',
        ListTypical: 'dashboard/ListTypical',
        Chart: 'dashboard/Chart',
        ListProject: 'dashboard/ListProject',
        InfoPayment: 'wallet/InfoPayment',
        InfoInvestment: 'user/InfoInvestment',
      }),
      fields() {
        return [
          {
            key: 'project_name',
            sortable: false,
            label: this.$t('dashboard.table.name'),
            class: 'text-center align-middle',
          },
          {
            key: 'total_inves_project',
            sortable: false,
            label: this.$t('dashboard.table.investment'),
            class: 'text-center align-middle',
          },
          {
            key: 'profit_received',
            sortable: false,
            label: this.$t('dashboard.table.profit_received'),
            class: 'text-center align-middle',
          },
          {
            key: 'profit_today',
            sortable: false,
            label: this.$t('dashboard.table.day_profit'),
            class: 'text-center align-middle',
          },
          {
            key: 'total_expected_profit',
            sortable: false,
            label: this.$t('dashboard.table.total_profit'),
            class: 'text-center align-middle',
          },
          {
            key: 'investment_Status',
            sortable: false,
            label: this.$t('dashboard.table.status'),
            class: 'text-center align-middle',
          },
          {
            key: 'project_id',
            sortable: false,
            label: '',
            class: 'text-center align-middle',
          },
        ];
      },
      ProjectList() {
        return [
          {
            id: 1,
            name: 'Dự Án 1',
          },
        ];
      },
    },
    methods: {
      onChangePage(payload) {
        this.$store.dispatch('dashboard/req_getListProjectTypical', {
          page: payload,
        });
      },
      getTotalVolume({ vnd, usd }) {
        console.log(vnd, usd);
        const totalUSD = parseFloat(usd) * parseFloat(this.Rate[10]);
        const totalVND = parseFloat(vnd);
        const volume = this.TruncateToDecimals(totalVND + totalUSD, '', 3);
        return volume;
      },
      getTotalVolume2({ vnd, usd }) {
        const totalUSD = parseFloat(usd) * parseFloat(this.Rate[10]);
        const totalVND = parseFloat(vnd);
        const volume = totalVND + totalUSD;
        return volume;
      },
      TruncateToDecimals2(num, type, dec = 2) {
        //   if (!dec) dec = 2;
        const numberFormat = parseFloat(num.toFixed(10));
        const d = numberFormat.toString().split('.');
        if (type == 1) {
          return `${numeral(d[0]).format(0, 0)}`;
        }
        return `${numeral(d[0]).format(0, 0)}${
          d[1] ? `.${d[1].slice(0, dec)}` : ''
        }`;
      },
      withDraw() {
        if (this.InfoInvestment.status === -1) {
          this.$bvModal.show('modal-updateKYC');
          return;
        }
        if (this.InfoPayment.setting_withdraw == 0) {
          this.$toastr.w('Chức Năng Rút Đang Bảo Trì!', 'Có Lỗi Đã Xảy Ra!');
          return;
        }
        this.$bvModal.show('modal-withdraw');
      },
      transfer() {
        if (this.InfoInvestment.status === -1) {
          this.$bvModal.show('modal-updateKYC');
          return;
        }
        if (this.InfoPayment.setting_withdraw == 0) {
          this.$toastr.w('Chức Năng Rút Đang Bảo Trì!', 'Có Lỗi Đã Xảy Ra!');
          return;
        }
        this.$bvModal.show('modal-transfer');
      },
      getClass(status) {
        if (status === 1) {
          return {
            class: 'text-success',
            text: 'Thành Công',
          };
        }
        if (status === -1) {
          return {
            class: 'text-danger',
            text: 'Đã Huỷ',
          };
        }
        if (status === -2) {
          return {
            class: 'text-danger',
            text: 'Rút Vốn',
          };
        }
        return {
          class: 'text-warning',
          text: 'Đang Tiến Hành',
        };
      },
    },
    created() {
      this.$store.dispatch('dashboard/req_getStatistical');
      this.$store.dispatch('investment/req_getListProjectInvest');
      this.$store.dispatch('dashboard/req_getListProjectTypical');
      this.$store.dispatch('dashboard/req_getChartData', {
        project: 10,
        date_type: 'month',
      });
      this.$store.dispatch('user/req_getInforInvestment');
      this.$store.dispatch('dashboard/req_getListProjectID');
    },
  };
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container class="dashboard">
      <b-row class="overflow-hidden py-4">
        <b-col cols="12" md="6" lg="6" xl="4" class="my-2">
          <div class="box-balance  ">
            <div class="box-title ">
              VÍ DOANH THU
            </div>
            <div class="box-body">
              <div class="box-main-balance">
                <div
                  class="amount fw-medium text-black font-size-20"
                  v-if="Statistical && Statistical.balance_pending_profit"
                >
                  <ICountUp
                    :key="
                      getTotalVolume2({
                        usd: Statistical.balance_pending_profit.totalUSD,
                        vnd: Statistical.balance_pending_profit.totalVND,
                      })
                    "
                    :delay="2000"
                    :endVal="
                      getTotalVolume2({
                        usd: Statistical.balance_pending_profit.totalUSD,
                        vnd: Statistical.balance_pending_profit.totalVND,
                      })
                    "
                    :options="options"
                  />
                </div>
              </div>
              <div class="button-group">
                <b-button
                  variant="info"
                  class="btn-gradient-1 btn-120 my-2"
                  @click="withDraw"
                >
                  Rút Tiền
                </b-button>
                <b-button
                  v-if="false"
                  variant="info"
                  class="btn-gradient-1 btn-120 my-2"
                  @click="transfer"
                >
                  Chuyển Tiền
                </b-button>
                <router-link
                  :to="{ name: 'InvestMent' }"
                  variant="info"
                  class="btn-gradient-outline-1 btn-120 d-flex align-items-center justify-content-center my-2"
                >
                  Tái Đầu Tư
                </router-link>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="6" xl="4" class="my-2">
          <div class="box-balance box-balance2  ">
            <div class="box-title ">
              DOANH THU CÒN LẠI
            </div>
            <div class="box-body">
              <div class="box-main-received">
                <div
                  class="amount fw-medium text-black font-size-20"
                  v-if="Statistical && Statistical.total_remaining_revenue"
                >
                  <ICountUp
                    :key="
                      getTotalVolume2({
                        usd:
                          Statistical.total_remaining_revenue
                            .total_remaining_revenue_usd,
                        vnd:
                          Statistical.total_remaining_revenue
                            .total_remaining_revenue_vnd,
                      })
                    "
                    :delay="2000"
                    :endVal="
                      getTotalVolume2({
                        usd:
                          Statistical.total_remaining_revenue
                            .total_remaining_revenue_usd,
                        vnd:
                          Statistical.total_remaining_revenue
                            .total_remaining_revenue_vnd,
                      })
                    "
                    :options="options"
                  />
                </div>
              </div>
              <div class="button-group">
                <router-link
                  :to="{ name: 'ManagerInvestment' }"
                  class="btn btn-info btn-gradient-1 btn-120 uppercase d-flex align-items-center justify-content-center"
                >
                  Danh Sách Dự Án Đang Đầu Tư
                </router-link>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" lg="12" xl="4">
          <b-row>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance second box-balance2  ">
                <div class="box-title ">
                  DOANH THU HÔM NAY
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium "
                      v-if="Statistical && Statistical.getTodayRevenue"
                    >
                      <ICountUp
                        :delay="2000"
                        :endVal="
                          getTotalVolume2({
                            usd: Statistical.getTodayRevenue.totalUSD,
                            vnd: Statistical.getTodayRevenue.totalVND,
                          })
                        "
                        :options="options"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6" xl="12" class="my-2 ">
              <div class="box-balance   second">
                <div class="box-title ">
                  LỆNH RÚT ĐANG CHỜ
                </div>
                <div class="box-body">
                  <div class="box-main-balance">
                    <div
                      class="amount fw-medium "
                      v-if="
                        Statistical && Statistical.total_widthraw_pending_profit
                      "
                    >
                      <ICountUp
                        :delay="2000"
                        :endVal="
                          getTotalVolume2({
                            usd:
                              Statistical.total_widthraw_pending_profit
                                .totalUSD,
                            vnd:
                              Statistical.total_widthraw_pending_profit
                                .totalVND,
                          })
                        "
                        :options="options"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-5" v-if="ListProject.length >= 1">
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-between pe-lg-5"
        >
          <div class="invest-dashboard text-black m-0 p-0">
            Báo Cáo Doanh Thu
          </div>
          <div class="select-project d-flex">
            <b-form-select
              class="text-white"
              v-model="projectID"
              :options="ListProject"
              value-field="project_id"
              text-field="project_name"
            >
            </b-form-select>
            <b-form-select
              style="max-width:150px!important;min-width: 100px;"
              class="text-white text-center ms-2"
              v-model="type"
              :options="listFilter"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
        </b-col>
        <b-col cols="12">
          <Line-Chart v-if="showChart" :chartData="Chart" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="box-investing">
            <div class="box-title">
              {{ $t('dashboard.list_investing') }}
            </div>
            <div class="box-body">
              <div class="table-reponsive">
                <b-table striped hover :items="Project.list" :fields="fields">
                  <template #cell(profit_received)="data">
                    {{ data.item.profit_received.profit_vnd }}
                  </template>
                  <template #cell(project_id)="data">
                    <router-link
                      class="btn btn-gradient-outline-2"
                      :to="{
                        name: 'ProjectDetail',
                        params: { slug: data.item.project_slug },
                      }"
                    >
                      Chi Tiết
                    </router-link>
                    <a
                      class="btn btn-warning"
                      :href="data.item.url"
                      v-if="data.item.project_status == 1"
                      target="_blank"
                    >
                      Xem hợp đồng
                    </a>
                  </template>
                  <template #cell(investment_Status)="data">
                    <p
                      class="mb-0"
                      :class="getClass(data.item.investment_Status).class"
                    >
                      {{ getClass(data.item.investment_Status).text }}
                    </p>
                  </template>
                  <template #cell(total_expected_profit)="data">
                    {{ TruncateToDecimals2(data.item.total_expected_profit) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="dashboard">
      <div class="invest-dashboard">
        Dự Án Mới
      </div>
      <ListProject :ListProject="ListTypical" @pageChange="onChangePage" />
    </b-container>
    <!-- Withdraw -->
    <b-modal
      id="modal-withdraw"
      scrollable
      title-class="font-18"
      hide-footer
      hide-header
      modal-class="modal-pc-show"
    >
      <div class="box-withdraw">
        <div class="title">
          <h3>
            RÚT TIỀN DOANH THU
          </h3>
          <div class="close" @click="$bvModal.hide('modal-withdraw')">X</div>
        </div>

        <withdraw-vnd
          @closeWithdraw="$bvModal.hide('modal-withdraw')"
        ></withdraw-vnd>
      </div>
    </b-modal>
    <!-- Transfer -->
    <b-modal
      id="modal-transfer"
      scrollable
      title-class="font-18"
      hide-footer
      hide-header
      modal-class="modal-pc-show"
    >
      <div class="box-withdraw">
        <div class="title">
          <h3>
            CHUYỂN TIỀN DOANH THU
          </h3>
          <div class="close" @click="$bvModal.hide('modal-transfer')">X</div>
        </div>

        <transfer-vnd
          @Closetransfer="$bvModal.hide('modal-transfer')"
        ></transfer-vnd>
      </div>
    </b-modal>
    <b-modal
      id="modal-updateKYC"
      scrollable
      title="Cập nhật KYC"
      title-class="font-18"
      hide-footer
      hide-header
    >
      <div class="box-kyc">
        <div class="close" @click="$bvModal.hide('modal-updateKYC')">X</div>
        <InfoInvestment />
      </div>
    </b-modal>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
  #modal-updateKYC {
    .modal-body {
      padding: 0;
      .box-kyc {
        width: 100%;
        min-height: 40px;
        border-radius: 10px;
        position: relative;
        margin-bottom: 1.25rem;
        padding-top: 0px;
        .close {
          position: absolute;
          top: 8px;
          right: 10px;
          color: #003395;
          font-weight: bold;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ccc;
          border-radius: 50%;
          padding: 5px;
          cursor: pointer;
        }
        .box-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 40px;
          padding: 0 1.25rem;
          background-color: #ffff;
          border-radius: 10px 10px 10px 10px;
          .text {
            color: #000;
            font-weight: 600;
            font-size: 20px;
            text-transform: capitalize;
            .text-warning {
              font-size: clamp(15px, 2vw, 16px);
            }
          }
          .icon {
            cursor: pointer;
            img {
              height: 20px;
              width: auto;
            }
            &.active {
              transform: rotate(180deg);
            }
          }
        }
        .content-box {
          padding: 1.25rem;
          .text-error {
            color: red;
            font-size: 13px;
            font-weight: 700;
            text-transform: capitalize;
          }
          #Fromdate {
            padding: 2px 5px 0px 0px !important;
          }
          .form-group {
            label {
              font-weight: 600;
              color: #fff;
              font-size: 16px;
              margin-bottom: 5px;
              text-transform: capitalize;
            }
            select,
            input {
              width: 100%;
              border: 0;
              border-bottom: 2px solid #e9ecef;
              border-radius: 0;
              height: 40px;
              font-size: clamp(15px, 1vw, 16.2px);
              font-weight: 600;
              font-size: 18px;
              color: #000;
              &:focus {
                box-shadow: unset;
                border-bottom: 2px solid #009751;
              }
              &::placeholder {
                font-weight: 500;
                font-size: clamp(13px, 1vw, 15px);
              }
            }
            .form-control {
              border: 0;
              border-bottom: 2px solid #e9ecef;
              border-radius: 0;
              height: 40px;
              font-size: clamp(15px, 1vw, 16.2px);
              font-weight: 600;
              font-size: 18px;
              color: #000;
              &:focus {
                box-shadow: unset;
                border-bottom: 2px solid #009751;
              }
              &::placeholder {
                font-weight: 500;
                font-size: clamp(13px, 1vw, 15px);
              }
            }
          }
          .close {
            color: #000;
          }
          .removi-img {
            position: absolute;
            top: calc(50% - 15px);
            left: 0;
            right: 0;
            margin: auto;
            background: #f3d91f;
            border: 1px #f3d91f solid;
            border-radius: 5px;
            padding: 7px 20px;
            opacity: 0;
            z-index: 20;
            width: 200px;
            transition: 0.3s;
            transform: translateY(100%);
            color: #000 !important;
          }
          .show-img:hover .removi-img {
            transform: translateY(0);
            opacity: 1;
          }
          .show-img {
            padding: 10px !important;
            height: auto !important;
            position: relative !important;
          }
          .show-img img {
            position: relative;
            z-index: 10;
            max-width: 225px;
          }
          .show-img {
            &:hover {
              &::after {
                background: rgba(0, 0, 0, 0.3);
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                border-radius: 10px;
                height: 100%;
                z-index: 11;
                content: '';
              }
            }
          }
          svg {
            font-size: 30px;
          }
          #uploadImage {
            .avatarEmpty {
              background: #1111111f;
              padding: 45px 0;
              color: #424242;
              border-radius: 10px;
              height: 180px;
              margin-bottom: 23px;
              width: 100%;
              position: relative;
              cursor: pointer;
              text-align: center;

              .fileUpload {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 22;
                outline: none;
                opacity: 0;
              }

              p {
                font-size: 20px;
                font-weight: 500;
                margin-top: 20px;
                margin-bottom: 0;
                color: #000;
                opacity: 0.8;
              }
            }

            .imgInfo {
              text-align: center;
              margin-bottom: 20px;

              .colorGreen {
                color: #25e69c;
                margin: 0 10px;
              }
            }
          }
        }
      }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #50a5f1;
      }
    }
  }
  #modal-withdraw,
  #modal-transfer {
    .box-withdraw {
      width: 100%;
      min-height: 40px;
      border-radius: 10px;
      position: relative;
      margin-bottom: 1.25rem;
      padding-top: 0px;
      .close {
        color: #003395;
        font-weight: bold;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ccc;
        border-radius: 50%;
        padding: 5px;
        cursor: pointer;
      }
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        padding: 0 5px;
        min-height: 35px;
        border-radius: 5px;
        box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.349);
        h3 {
          color: #000;
          margin: 0;
        }
      }
      .form-group {
        max-width: 425px;
        margin: 15px auto;
        label {
          width: 100%;
          font-size: 17px;
          font-weight: 600;
          margin: 0px 0px 5px;
        }
        input.money-amount {
          width: 100%;
          border: 2px solid rgb(128, 128, 128);
          height: 40px;
          border-radius: 1px;
          font-size: 16px;
          font-weight: 700;

          padding: 0 10px;
        }
        .custom-checkbox {
          margin-top: 30px;
          display: flex;
          align-items: center;
          &.bg-white {
            input {
              background-color: #fff;
              border: 2px solid rgb(128, 128, 128);
            }
          }
          input {
            height: 30px;
            width: 30px;
          }
          label {
            margin: 0 5px;
          }
        }
        button {
          font-size: 17px;
          font-weight: 700;
        }
      }
      .form-control {
        background-color: #fff;
        border: 2px solid rgb(128, 128, 128);
        height: 40px;
        border-radius: 1px;
        font-size: 16px;
        font-weight: 600;
        &:hover,
        &:focus {
          color: #000;
        }
      }
      .text-pop {
        font-size: 18px;
        max-width: 425px;
        margin: 25px auto 10px;
        text-align: center;
        text-transform: capitalize;
        color: #fff !important;
        letter-spacing: 0.5px;
        span {
          font-weight: 700;
        }
      }
    }
  }
  .title-dashboard {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
  }
  .dashboard {
    select,
    input {
      width: 100%;
      max-width: 300px;
      min-width: 200px;
      border: 1px solid #e9ecef;
      height: 40px;
      font-size: clamp(13px, 1vw, 14.2px);
      font-weight: 600;
      background: #fff;
      border-radius: 5px;
      padding-left: 5px;
      color: #000 !important;
      &:focus {
        box-shadow: 0 0 0 1px rgba(56, 169, 73, 45%);
      }
      &::placeholder {
        font-weight: 500;
        font-size: clamp(13px, 1vw, 15px);
      }
    }
    .box-balance {
      border: none;
      box-shadow: 0 5px 15px 1px rgb(0, 0, 0, 0.28);
      border-radius: 15px;
      background: linear-gradient(to top, #008cff, #ffffff);
      // min-height: 200px;
      height: 100%;
      width: 100%;
      max-width: 600px;
      border: 2px solid #00389b !important;
      &.second {
        background: linear-gradient(to bottom, #008cff, #003395);
        .box-title {
          color: #fff;
          &::after {
            content: '';
            width: 85%;
            height: 3px;
            background: #7fa3e2;
          }
        }
      }
      .box-title {
        padding: 10px;
        font-size: 1.4em;
        color: #000;
        text-align: left;
        font-weight: 700;
        position: relative;
        z-index: 10;
        // background-color: #240b59;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        padding-left: 10%;
        &::after {
          content: '';
          width: 85%;
          height: 3px;
          background: #00389b;
          position: absolute;
          bottom: 0;
          left: 5%;
          margin: auto;
        }
      }
      .box-body {
        padding: 10px;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        min-height: calc(100% - 60px);
        .box-main-balance,
        .box-main-received {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.2em;
          min-height: 70px;
          .name {
            margin: 10px 0;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            z-index: 10;
          }
          .amount {
            margin: 10px 0;
            font-weight: bold;
            position: relative;
            z-index: 10;
            text-align: center;
            span {
              font-size: 24px;
            }
          }
          @media (max-width: 425px) {
            flex-direction: column;
          }
        }
        .button-group {
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;
          a,
          .btn {
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1px;
          }
          a {
            text-transform: uppercase;
          }
        }
      }
    }
    .invest-dashboard {
      padding: 15px 15px 5px;
      font-size: 1.6em;
      color: #000;
      text-align: left;
      font-weight: 600;
      margin-bottom: 10px;
      text-transform: uppercase;
    }
    .box-investing {
      margin-top: 50px;
      margin-bottom: 20px;
      .box-title {
        padding: 15px 15px 5px;
        font-size: 1.6em;
        color: #000;
        text-align: left;
        font-weight: 600;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
      .box-body {
        padding: 10px 0px;
        border: none;
        box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
        border-radius: 15px;
        background: linear-gradient(to bottom, #008cff, #003395);
        min-height: 200px;
        width: 100%;
        border: 1px solid #124cfe42;
        table {
          thead {
            color: red;
            tr {
              th {
                color: #fff;
                font-size: 1.2em;
              }
            }
          }
          tbody {
            tr {
              td {
                font-size: 1.1em;
                padding: 10px 0.75rem;
              }
            }
          }
        }
      }
    }

    .banner-box {
      background: {
        size: cover !important;
        position: center center !important;
      }
      border-radius: 15px;
      min-height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      &:after {
        content: '';
        background-color: rgb(0, 0, 0, 0.5);
        border-radius: 15px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
      }
      .banner-content {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px 25px;
        z-index: 2;
        overflow: hidden;
        .left {
          flex: 0 0 50%;
          max-width: 170px;
          border-radius: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            filter: drop-shadow(0px 0px 0px #fff);
            width: 100%;
            height: auto;
            border-radius: 15px;
          }
        }
        .right {
          margin-left: 5%;
          flex: 1 1 auto;
          max-width: 768px;
          .banner-title {
            color: #f9cf00;
            font-size: 1.4em;
            font-weight: 600;
            margin-bottom: 15px;
          }
          .banner-description {
            color: #fff;
            font-size: 1.2em;
            font-weight: 500;
          }
        }
        @media (max-width: 767px) {
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .left {
            flex: 0 0 100%;
            margin-bottom: 15px;
          }
          .right {
            flex: 0 0 100%;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
</style>
